<template>
  <div v-show="info.status !== 'show'">
    <a-input-number
        class="min"
        v-model:value="minValue"
        :disabled="info.status === 'show'"
        placeholder="最小值"
        :precision="widget.scale"
    />
    -
    <a-input-number
        class="max"
        v-model:value="maxValue"
        :disabled="info.status === 'show'"
        placeholder="最大值"
        :precision="widget.scale"
    />
  </div>
  <div v-show="info.status === 'show'" class="view">
    <number-range-table :data="data" v-bind="$props"/>
  </div>
</template>

<script lang="ts" setup>
import {computed, defineProps} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import _ from "lodash";
import {NumberRangeFieldType} from "@/components/business/crud/interface/FieldType";
import NumberRangeTable from "@/components/business/crud/widgets/impl/NumberRangeTable.vue";

const props = defineProps<{
  propName: string;
  widget: NumberRangeFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const minValue = computed({
  get() {
    return data.value[props.widget.minPropName];
  },
  set(val?: number) {
    val = _.isFinite(val) ? val : undefined;
    if (val !== undefined && props.widget.type === 'string') {
      data.value[props.widget.minPropName] = val.toString();
    } else {
      data.value[props.widget.minPropName] = val;
    }
  }
})

const maxValue = computed({
  get() {
    return data.value[props.widget.maxPropName];
  },
  set(val?: number) {
    val = _.isFinite(val) ? val : undefined;
    if (val !== undefined && props.widget.type === 'string') {
      data.value[props.widget.maxPropName] = val.toString();
    } else {
      data.value[props.widget.maxPropName] = val;
    }
  }
})
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}
</style>
